// @flow
import BaseComponent from '../base_component/base_component';
import componentLocator from '../../assets/javascripts/component_locator';
import {deferrablePost} from '../../assets/javascripts/offline_handler';
import startCase from 'lodash-es/startCase';

var rowTemplate = `
    <div class="empty row custom-row item-group x12 s6">
        <div class=mover></div>
        <div class=remove-row><i class="fa fa-close"></i></div>
        <div class=add-item><i class="fa fa-plus"></i></div>
        <div class="row-items item-container h-12"></div>
    </div>
`;

var cols = [[12], [6, 6], [4, 4, 4], [3, 3, 3, 3],
            [2, 3, 2, 3, 2], [2, 2, 2, 2, 2]];

export default class CustomDashboard extends BaseComponent {

    initialize() {
        this.isEditing = false;
        this.handlers = {};
        this.activeMenu = null;
        this.attachHandlers();
        this.handleMovers();
        this.find('.item-container .wrapper').each((_, e) => {
            let parts = $(e).attr('id').split('_');
            window.__componentAdapter.render(parts[parts.length - 1], false);
        });
    }

    attachHandlers() {
        this.find('.custom-dashboard').on('click', '.remove-item', (e: JQueryEventObject) => {
            this._removeComponent(e.target);
        })
        this.find('.custom-dashboard').on('click', '.remove-row', (e: JQueryEventObject) => {
            this._removeRow(e.target);
        })
        this.handlers.addMenuItem = (e: JQueryEventObject) => {
            this._openAddMenu($(e.target));
            e.stopPropagation();
        }
        this.find('.custom-dashboard').on('click', '.add-item', this.handlers.addMenuItem);
        this.find('.add-row').click(() => {
            if (this.find('.rows > .row').length >= 4) return;

            this.find('.rows').append(rowTemplate);
            this._fixRowHeight();
        });
        this.find('.create-sidebar, .remove-sidebar').click(() => {
            this.find('.sidebar-content').toggle();
            this.find('.create-sidebar').toggle();
        });
    }

    _removeComponent(element: EventTarget) {
        let $wrapper = $(element).closest('.remove-item').next();
        let component = window.getComponent($wrapper[0]);
        if (component) {
            component.dismount();
            componentLocator.deleteComponent(
                parseInt($wrapper.first().attr('data-component-id')));
        }
        let $outer = $wrapper.closest('.outer-item-group');
        $outer.removeClass('full');
        $outer.closest('.custom-dashboard').removeClass(`${$outer.attr('class').split(' ')[0]}-full`);

        let $row = $wrapper.closest('.row');
        $wrapper.parent().remove();
        if ($row.find('.col').length === 0) {
            $row.find('.remove-row').show();
            $row.addClass('empty');
        } else {
            this._fixColWidth($row);
        }
    }

    _removeRow(element: EventTarget) {
        $(element).closest('.row').remove();
        this._fixRowHeight();
    }

    _openAddMenu($element: JQuery) {
        if (this.activeMenu && this.activeMenu.is($element.closest('.add-item'))) {
            return this._addItem($element);
        } else if (this.activeMenu) {
            this._closeAddMenu();
        }
        $element = $element.closest('.add-item');
        $element.addClass('active');
        $element.find('.option').remove();
        this._getPossibleElements($element.closest('.outer-item-group')).forEach(component => {
            $element.append(`<div class=option data-val=${component}>` +
                `${startCase(component)}</div>`);
        });

        this.activeMenu = $element;
        this.handlers.closeMenu = this._closeAddMenu.bind(this);
        $(document).on('click', this.handlers.closeMenu);
    }

    _getPossibleElements(itemGroup: JQuery): Array<any> {
        let activeElements = itemGroup.find('.item-container .col')
            .map((_, e) => $(e).attr('data-name')).toArray();
        return this.options[itemGroup.attr('data-items')].filter(e => !activeElements.includes(e));
    }

    _closeAddMenu() {
        $(document).off('click', this.handlers.closeMenu);

        if (this.activeMenu === null || this.activeMenu === undefined) return;

        this.activeMenu.removeClass('active');
        this.activeMenu = null;
    }

    _addItem($element: JQuery) {
        if (!$element.is('.option')) return;

        let $row = $element.closest('.item-group');
        let $rows = $element.closest('.outer-item-group');
        let name = $element.attr('data-val');
        let id = this.options[name].toString();
        let element = this._generateElement(id, name);
        $row.find('.item-container').append(element);
        window.__componentAdapter.render(id, false);

        let isFull = $rows.is($row) || this._getPossibleElements($rows).length == 0;
        $rows.toggleClass('full', isFull);
        $rows.closest('.custom-dashboard').toggleClass(`${$rows.attr('class').split(' ')[0]}-full`, isFull);

        $row.removeClass('empty');
        this._fixColWidth($row);
        this._closeAddMenu();
    }

    _generateElement(id: string, name: string) {
        return `<div class="col x12 s12 h-12" data-name="${name}">
            <div class="remove-item"><i class="fa fa-close"></i></div>
            <div class="wrapper" id="wrapper_${id}" data-component-id="${id}"></div>
        </div>`;
    }

    handleMovers() {
        let $component = $(this.component);
        let originalY = 0; // MouseY at move
        let netChange = 0;
        let [upperElement, upperHeight, upperH] = [$(), 0, 0];
        let [lowerElement, lowerHeight, lowerH] = [$(), 0, 0];

        let dragger = event => {
            let distanceMoved = event.pageY - originalY;
            if (distanceMoved > 0) {
                netChange = (distanceMoved / lowerHeight) * lowerH;
            } else if (distanceMoved < 0) {
                netChange = (distanceMoved / upperHeight) * upperH;
            }
            if (Math.abs(netChange) <= 0.8) return; 
            netChange = Math.round(netChange);

            let newUpperH = Math.max(1, Math.min(upperH + lowerH - 1, upperH + netChange));
            let newLowerH = Math.max(1, Math.min(upperH + lowerH - 1, lowerH - netChange));
            this._setRowClass(upperElement, newUpperH);
            this._setRowClass(lowerElement, newLowerH);
        };
        let onMouseUp = () => {
            $(window).off('mouseup', onMouseUp);
            $component.off('mousemove', dragger);
        }
        this.find('.custom-dashboard').on('mousedown', '.mover', (event: JQueryEventObject) => {
            lowerElement = $(event.target).parent();
            upperElement = lowerElement.prev();

            originalY = event.pageY;

            lowerH = this._getHClass(lowerElement);
            lowerHeight = lowerElement.height();
            upperH = this._getHClass(upperElement);
            upperHeight = upperElement.height();

            $(window).on('mouseup', onMouseUp);
            $component.on('mousemove', dragger);
        })
    }

    _getHClass(element: JQuery) {
        let hClass = element.attr('class').split(/\s+/)
            .filter(c => c.match(/s[0-9]{1,2}/))[0].substr(1);
        return parseInt(hClass);
    }

    _fixColWidth(row: JQuery) {
        let rowItems = row.find('.row-items').children();
        let colWidths = cols[rowItems.length - 1];
        rowItems.each((i, child) => this._setRowClass($(child), colWidths[i]));
    }

    _fixRowHeight(ignoreEmpty:boolean=false) {
        let rowCount = this.find(`.rows > .row${ignoreEmpty ? ':not(.empty)' : ''}`).length;
        this.find(`.rows > .row${ignoreEmpty ? ':not(.empty)' : ''}`).each((_, element) => {
            this._setRowClass($(element), 12 / rowCount)
        })
        this.find('.add-row').toggleClass('hide', this.find('.rows > .row').length === 4);
    }

    _setRowClass($row: JQuery, newValue: (string|number)) {
        $row.removeClass((_, name) => (name.match (/s[0-9]{1,2}/g) || []).join(' '))
            .addClass(`s${newValue}`);
    }

    functions() {
        return {
            toggle: (mode: string) => mode == 'EditLayout' ? this.toggleEditMode() : null
        }
    }

    toggleEditMode() {
        this.isEditing = !this.isEditing;
        this.find('.custom-dashboard').toggleClass('editing', this.isEditing);
        this._fixRowHeight(!this.isEditing);

        if (!this.isEditing) {
            this.saveStructure();
        };
    }

    saveStructure() {
        let sidebarName = $('.sidebar-items .col').attr('data-name');
        let topbarName = $('.topbar-items .col').attr('data-name');
        let layout = {sidebar: (sidebarName || null), top: (topbarName || null), rows: []}
        this.find('.rows > .row').each((_, row) => {
            let heightClass = row.className.match(/(?:^| )(s[0-9]{1,2})(?:$| )/)
            layout.rows.push({
                height: heightClass ? heightClass[1].substr(1) : '12',
                components: $(row).find('.row-items > .col[data-name]')
                    .map((_, e) => $(e).attr('data-name')).toArray()
            })
        });
        deferrablePost('/save_layout', {layout: JSON.stringify(layout)});
    }
}